import { API_DATE_FORMAT } from 'appConstants';
import {
  AGRONOMY_AGREEMENT_MAX_START_DATE,
  AGRONOMY_AGREEMENT_MIN_START_DATE,
} from 'appConstants/agronomyAgreement';
import type { IValidationField } from 'hooks/useValidations/types';
import { getFixedT } from 'i18next';
import * as yup from 'yup';

export default function agreementStartDate({ label = '' }: IValidationField) {
  const t = getFixedT(null, 'CreateAgronomyAgreement', 'CustomerDetails');

  const minDate = AGRONOMY_AGREEMENT_MIN_START_DATE.format(API_DATE_FORMAT);
  const maxDate = AGRONOMY_AGREEMENT_MAX_START_DATE.format(API_DATE_FORMAT);

  return yup
    .string()
    .label(label)
    .required(t('errors.required'))
    .default('')
    .isValidDate(t('errors.invalidDate'))
    .minDate(t('errors.minStartDate'), minDate)
    .maxDate(t('errors.maxStartDate'), maxDate);
}
